import React, { Component } from 'react';
import moment from 'moment';
import { Example, Properties, SourceCode } from 'examples';
import TimeInput from './TimeInput';
import Timepicker from '../Timepicker/Timepicker';


export default class TimeInputExample extends Component {

  constructor() {
    super();
    this.state = {
      selected: moment.utc('2016-12-02T00:00:00'),
    };
  }

  onChange = (date) => {
    this.setState({
      selected: date ? date.clone() : null,
    });
  };

  onClearNotice = (e) => window.showAppInfo('dismiss notice')


  onPropChange = e => {
    this.setState(e.target.value);
  };

  render() {
    const properties = { ...TimeInput.propTypes, ...Timepicker.propTypes };
    const defaultProperties = { ...TimeInput.defaultProps, ...Timepicker.defaultProps };

    return (
      <Example {...this.props}>
        <Properties defaultProps={defaultProperties} onChange={this.onPropChange} propTypes={properties} propValues={this.state}/>
        <TimeInput {...this.state} onChange={this.onChange} onClearNotice={this.onClearNotice}/>
        <SourceCode language="javascript" title="The onChange callback">
          {
            '/* For the TimeInput view to be updated the onChange and selected prop must be implemented. Example: */\n' +
            '\n' +
            'constructor() {\n' +
            '  this.state = { selected: moment() }\n' +
            '}\n' +
            '\n' +
            'onChange(date) {\n' +
            '  // the date parameter is a moment object\n' +
            '  this.setState({ selected: date })\n' +
            '}\n' +
            '\n' +
            'render() {\n' +
            '  return (<TimeInput onChange={this.onChange.bind(this)} selected={this.state.selected}/>);\n' +
            '}'
          }
        </SourceCode>
        <SourceCode querySelector=".core-timeinput"/>
      </Example>
    );
  }

}
